export default __webpack_public_path__ + "static/media/mail.d250eba5.svg";